var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        margin: "0 auto",
        width: "980px",
        border: "0px solid #E8E8EC",
      },
      attrs: { id: "printMChat" },
    },
    [
      _c("span", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        ref: "data",
      }),
      _c("div", { staticClass: "page content" }, [
        _c("div", { staticClass: "title" }, [_vm._v("婴幼儿社会功能筛查")]),
        _c(
          "table",
          {
            staticClass: "container",
            staticStyle: { border: "none", "text-align": "left" },
            attrs: { cellspacing: "0", cellpadding: "0", border: "0" },
          },
          [
            _c("tbody", [
              _c(
                "tr",
                { staticStyle: { "line-height": "25px", border: "none" } },
                [
                  _c("td", { staticStyle: { border: "none" } }, [
                    _vm._v("测评机构： " + _vm._s(_vm.form.institution_name)),
                  ]),
                ]
              ),
              _c(
                "tr",
                { staticStyle: { "line-height": "25px", border: "none" } },
                [
                  _c("td", { staticStyle: { border: "none" } }, [
                    _vm._v("测评时间： " + _vm._s(_vm.form.medicalDate)),
                  ]),
                ]
              ),
              _vm._m(0),
            ]),
          ]
        ),
        _vm._m(1),
        _c(
          "table",
          {
            staticClass: "container",
            staticStyle: { border: "none", "text-align": "left" },
            attrs: { cellspacing: "0", cellpadding: "0", border: "0" },
          },
          [
            _c("tbody", [
              _c(
                "tr",
                { staticStyle: { "line-height": "25px", border: "none" } },
                [
                  _c(
                    "td",
                    {
                      staticStyle: { border: "none" },
                      attrs: { colspan: "1" },
                    },
                    [_vm._v("姓名： ")]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: { border: "none", "font-weight": "600" },
                      attrs: { colspan: "7" },
                    },
                    [_vm._v(_vm._s(_vm.form.name))]
                  ),
                ]
              ),
              _c(
                "tr",
                { staticStyle: { "line-height": "25px", border: "none" } },
                [
                  _c(
                    "td",
                    {
                      staticStyle: { border: "none" },
                      attrs: { colspan: "1" },
                    },
                    [_vm._v("性别： ")]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: { border: "none", "font-weight": "600" },
                      attrs: { colspan: "7" },
                    },
                    [_vm._v(_vm._s(_vm.form.gender === 1 ? "男" : "女"))]
                  ),
                ]
              ),
              _c(
                "tr",
                { staticStyle: { "line-height": "25px", border: "none" } },
                [
                  _c(
                    "td",
                    {
                      staticStyle: { border: "none" },
                      attrs: { colspan: "1" },
                    },
                    [_vm._v("年龄： ")]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: { border: "none", "font-weight": "600" },
                      attrs: { colspan: "7" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          (_vm.form.age + "").length > 0
                            ? _vm.form.age + "岁"
                            : ""
                        )
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "tr",
                { staticStyle: { "line-height": "25px", border: "none" } },
                [
                  _c(
                    "td",
                    {
                      staticStyle: { border: "none" },
                      attrs: { colspan: "1" },
                    },
                    [_vm._v("出生日期： ")]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: { border: "none", "font-weight": "600" },
                      attrs: { colspan: "7" },
                    },
                    [_vm._v(_vm._s(_vm.form.birthday))]
                  ),
                ]
              ),
              _c(
                "tr",
                { staticStyle: { "line-height": "25px", border: "none" } },
                [
                  _c(
                    "td",
                    {
                      staticStyle: { border: "none" },
                      attrs: { colspan: "1" },
                    },
                    [_vm._v("与儿童关系： ")]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: { border: "none", "font-weight": "600" },
                      attrs: { colspan: "7" },
                    },
                    [_vm._v(_vm._s(_vm.form.relation))]
                  ),
                ]
              ),
            ]),
          ]
        ),
        _c(
          "table",
          {
            staticClass: "header",
            staticStyle: { "text-align": "center", "margin-top": "15px" },
            attrs: { cellspacing: "0", cellpadding: "0", border: "0" },
          },
          [
            _c("tbody", [
              _vm._m(2),
              _vm._m(3),
              _c("tr", { staticStyle: { "line-height": "30px" } }, [
                _c("td", [_vm._v("1")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[0] === "1" ? "是" : "否")),
                ]),
                _c("td", [_vm._v("7")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[6] === "1" ? "是" : "否")),
                ]),
                _c("td", [_vm._v("13")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[12] === "1" ? "是" : "否")),
                ]),
                _c("td", [_vm._v("19")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[18] === "1" ? "是" : "否")),
                ]),
              ]),
              _c("tr", { staticStyle: { "line-height": "30px" } }, [
                _c("td", [_vm._v("2")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[1] === "1" ? "是" : "否")),
                ]),
                _c("td", [_vm._v("8")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[7] === "1" ? "是" : "否")),
                ]),
                _c("td", [_vm._v("14")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[13] === "1" ? "是" : "否")),
                ]),
                _c("td", [_vm._v("20")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[19] === "1" ? "是" : "否")),
                ]),
              ]),
              _c("tr", { staticStyle: { "line-height": "30px" } }, [
                _c("td", [_vm._v("3")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[2] === "1" ? "是" : "否")),
                ]),
                _c("td", [_vm._v("9")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[8] === "1" ? "是" : "否")),
                ]),
                _c("td", [_vm._v("15")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[14] === "1" ? "是" : "否")),
                ]),
                _c("td"),
                _c("td"),
              ]),
              _c("tr", { staticStyle: { "line-height": "30px" } }, [
                _c("td", [_vm._v("4")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[3] === "1" ? "是" : "否")),
                ]),
                _c("td", [_vm._v("10")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[9] === "1" ? "是" : "否")),
                ]),
                _c("td", [_vm._v("16")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[15] === "1" ? "是" : "否")),
                ]),
                _c("td"),
                _c("td"),
              ]),
              _c("tr", { staticStyle: { "line-height": "30px" } }, [
                _c("td", [_vm._v("5")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[4] === "1" ? "是" : "否")),
                ]),
                _c("td", [_vm._v("11")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[10] === "1" ? "是" : "否")),
                ]),
                _c("td", [_vm._v("17")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[16] === "1" ? "是" : "否")),
                ]),
                _c("td"),
                _c("td"),
              ]),
              _c("tr", { staticStyle: { "line-height": "30px" } }, [
                _c("td", [_vm._v("6")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[5] === "1" ? "是" : "否")),
                ]),
                _c("td", [_vm._v("12")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[11] === "1" ? "是" : "否")),
                ]),
                _c("td", [_vm._v("18")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.problems[17] === "1" ? "是" : "否")),
                ]),
                _c("td"),
                _c("td"),
              ]),
            ]),
          ]
        ),
        _c(
          "table",
          {
            staticStyle: { "text-align": "center", "margin-top": "15px" },
            attrs: { cellspacing: "2", cellpadding: "2", border: "3" },
          },
          [
            _c("tbody", [
              _vm._m(4),
              _vm._m(5),
              _c("tr", { staticStyle: { "line-height": "30px" } }, [
                _c(
                  "td",
                  { staticStyle: { width: "30px" }, attrs: { colspan: "2" } },
                  [_vm._v("测评得分")]
                ),
                _c("td", { attrs: { colspan: "6" } }, [
                  _vm._v(_vm._s(_vm.form.totalScore)),
                ]),
              ]),
              _vm._m(6),
              _c("tr", { staticStyle: { "line-height": "30px" } }, [
                _c(
                  "td",
                  { staticStyle: { width: "33px" }, attrs: { colspan: "2" } },
                  [_vm._v("测评结果")]
                ),
                _c("td", {
                  staticStyle: {
                    "text-align": "left",
                    "flex-wrap": "wrap",
                    "justify-content": "flex-start",
                  },
                  attrs: { colspan: "6" },
                  domProps: {
                    innerHTML: _vm._s(_vm.form.result ? _vm.form.result : ""),
                  },
                }),
              ]),
              _c("tr", { staticStyle: { "line-height": "30px" } }, [
                _c(
                  "td",
                  { staticStyle: { width: "33px" }, attrs: { colspan: "2" } },
                  [_vm._v("评分说明")]
                ),
                _c(
                  "td",
                  {
                    staticStyle: {
                      "text-align": "left",
                      "flex-wrap": "wrap",
                      "justify-content": "flex-start",
                    },
                    attrs: { colspan: "6" },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.form.scoreRemark ? _vm.form.scoreRemark : "")
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "tr",
      { staticStyle: { "line-height": "25px", border: "none" } },
      [
        _c("td", { staticStyle: { border: "none" } }, [
          _vm._v("测评内容： 婴幼儿社区功能筛查"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "table",
      {
        staticClass: "container",
        staticStyle: {
          border: "none",
          "text-align": "center",
          "margin-top": "10px",
          "margin-bottom": "10px",
        },
        attrs: { cellspacing: "0", cellpadding: "0", border: "0" },
      },
      [
        _c("tbody", [
          _c(
            "tr",
            {
              staticStyle: {
                "background-color": "#ddd",
                height: "5px",
                "line-height": "35px",
                "font-size": "18px",
                "font-weight": "600",
              },
            },
            [_c("td", [_c("p", [_vm._v("第一部分 受测试者基本信息")])])]
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "tr",
      {
        staticStyle: {
          "background-color": "#ddd",
          height: "35px",
          "line-height": "35px",
        },
      },
      [
        _c(
          "td",
          {
            staticStyle: { "font-size": "18px", "font-weight": "600" },
            attrs: { colspan: "8" },
          },
          [_vm._v("第二部分 结果信息")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", { staticStyle: { "background-color": "#9e9e9e1f" } }, [
      _c("td", [_vm._v("题号")]),
      _c("td", [_vm._v("结果")]),
      _c("td", [_vm._v("题号")]),
      _c("td", [_vm._v("结果")]),
      _c("td", [_vm._v("题号")]),
      _c("td", [_vm._v("结果")]),
      _c("td", [_vm._v("题号")]),
      _c("td", [_vm._v("结果")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "tr",
      {
        staticStyle: {
          "background-color": "#ddd",
          height: "35px",
          "line-height": "35px",
        },
      },
      [
        _c(
          "td",
          {
            staticStyle: { "font-size": "18px", "font-weight": "600" },
            attrs: { colspan: "8" },
          },
          [_vm._v("第三部分 结论信息")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", { staticStyle: { "line-height": "30px" } }, [
      _c("td", { staticStyle: { width: "30px" }, attrs: { colspan: "2" } }, [
        _vm._v("结论类型"),
      ]),
      _c("td", { attrs: { colspan: "6" } }, [_vm._v("总分")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", { staticStyle: { "line-height": "30px" } }, [
      _c("td", { staticStyle: { width: "30px" }, attrs: { colspan: "2" } }, [
        _vm._v("得分说明"),
      ]),
      _c(
        "td",
        {
          staticStyle: {
            "text-align": "left",
            "flex-wrap": "wrap",
            "justify-content": "flex-start",
          },
          attrs: { colspan: "6" },
        },
        [
          _vm._v(
            "\n            量表项目11、18、20、22回答为“3分”，其余项目回答“0分”视为筛查不通过;若项目2、7、9、13、14、15中有两项或以上为“3分”，或者在全部项目中有三个项目或以上为“3分”，视为存在孤独症或其他发育障碍的风险;总分>17分视为筛查不通过。\n          "
          ),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }